import installationInstructions from './installationInstructions';

const pexBulbContent = {
  installationInstructions
}

export { pexBulbContent };
